import * as React from 'react';
import { checkValue } from 'src/components/common/helper';
import { ModuleProps } from 'src/utils/module-util';
import { CpCmsLiteContentComponent } from 'src/components/common/modules/v1/content/content-v1/code-split/content-component';
import { CpCmsLiteContentComponentV2 } from 'src/components/common/modules/v1/content/content-v2/code-split/content-component';
import { CpCmsLiteContentComponentV3 } from 'src/components/common/modules/v1/content/content-v3/code-split/content-component';
import { CpCmsLiteContentComponentV5 } from 'src/components/common/modules/v1/content/content-v5/code-split/content-component';
import { CpCmsLiteContentComponentV6 } from 'src/components/common/modules/v1/content/content-v6/code-split/content-component';
import { CpCmsLiteContentComponentV7 } from 'src/components/common/modules/v1/content/content-v7/code-split/content-component';
import { CpCmsLiteContentComponentV8 } from 'src/components/common/modules/v1/content/content-v8/code-split/content-component';

// Css Style Import
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v1/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v2/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v3/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v5/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v6/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v7/styles/_content-section.css');
import(/* webpackChunkName: "v1-content-section-styles" */ 'src/components/common/modules/v1/content/content-v8/styles/_content-section.css');

const ContentModule = (props: ModuleProps) => {
  const loadContentModule = (type: string, props: any) => {
    switch (type) {
      case 'Style-1':
        return <CpCmsLiteContentComponent {...props} />;
      case 'Style-2':
        return <CpCmsLiteContentComponentV2 {...props} />;
      case 'Style-3':
        return <CpCmsLiteContentComponentV3 {...props} />;
      case 'Style-5':
        return <CpCmsLiteContentComponentV5 {...props} />;
      case 'Style-6':
        return <CpCmsLiteContentComponentV6 {...props} />;
      case 'Style-7':
        return <CpCmsLiteContentComponentV7 {...props} />;
      case 'Style-8':
        return <CpCmsLiteContentComponentV8 {...props} />;
      default:
        return <CpCmsLiteContentComponent {...props} />;
    }
  };

  return (
    <>
      {checkValue(props) &&
        checkValue(props?.data) &&        
        loadContentModule(props?.data?.moduleVariation, props)}
    </>
  );
};

export { ContentModule };
